import { api } from '@/api';

export const getCountries = (languageId) => {
  return api.get(`/api/kyc/v1/countries`, { params: { languageId: languageId } });
};
